import Icon from './Icon';

const VARIANTS = {
  primary: 'bg-primary-container text-on-primary hover:bg-primary shadow-xs',
  secondary:
    'bg-surface-container-lowest text-on-surface border border-outline-variant/40 hover:bg-surface-container-low hover:border-outline-variant',
  ghost: 'text-on-surface-variant hover:bg-surface-container hover:text-on-surface',
  muted: 'bg-surface-container text-on-surface hover:bg-surface-container-high',
  danger: 'bg-error-container/60 text-on-error-container hover:bg-error-container',
  dangerSolid: 'bg-error text-on-error hover:bg-on-error-container shadow-xs',
};

// Visible keyboard focus on every variant (DESIGN.md › Buttons)
const FOCUS = 'focus-visible:ring-2 focus-visible:ring-status-ok-dot focus-visible:ring-offset-2';

const SIZES = {
  sm: 'h-7 px-2.5 text-xs gap-1',
  md: 'h-8 px-3.5 text-xs gap-1.5',
  lg: 'h-10 px-4 text-sm gap-2',
};

export default function Button({
  variant = 'primary',
  size = 'md',
  icon,
  iconRight,
  className = '',
  type = 'button',
  children,
  ...rest
}) {
  return (
    <button
      type={type}
      className={`inline-flex items-center justify-center rounded-lg font-semibold whitespace-nowrap transition-colors outline-none disabled:opacity-50 disabled:cursor-not-allowed ${FOCUS} ${VARIANTS[variant]} ${SIZES[size]} ${className}`}
      {...rest}
    >
      {icon && <Icon name={icon} size={size === 'lg' ? 20 : 16} />}
      {children}
      {iconRight && <Icon name={iconRight} size={size === 'lg' ? 20 : 16} />}
    </button>
  );
}
